<script>
export default {
  name: 'MapEmbed',
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<template>
  <div class="mapouter">
    <div class="gmap_canvas">
      <iframe
        id="gmap_canvas"
        src="https://maps.google.com/maps?q=%CE%99%CE%B1%CF%84%CF%81%CE%BF%CF%8D%20%CE%9A%CE%B1%CF%84%CF%83%CE%B1%CE%BF%CF%8D%CE%BD%CE%B7%20%CE%A3%CF%80%CF%85%CF%81%CE%AF%CE%B4%CF%89%CE%BD,%20%CE%86%CE%B3%CE%B9%CE%BF%CF%82%20%CE%9D%CE%B9%CE%BA%CF%8C%CE%BB%CE%B1%CE%BF%CF%82,%2063078,%20%CE%95%CE%BB%CE%BB%CE%AC%CE%B4%CE%B1&t=&z=13&ie=UTF8&iwloc=&output=embed"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
      ></iframe>
      <!-- <a href="https://yt2.org">youtube to mp3</a><br /><a
        href="https://www.embedgooglemap.net"
      ></a> -->
    </div>
  </div>
</template>

<style scoped lang="scss">
iframe {
  width: 100%;
  min-height: var(--size-14-11);
}
.gmap_canvas {
  overflow: hidden;
  background: none !important;
}

.mapouter {
  position: relative;
  text-align: right;
}
</style>
